import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-16 h-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center mb-6">
        <i className="ri-emotion-sad-line text-3xl"></i>
      </span>
      <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
        页面不存在
      </h1>
      <p className="mt-3 text-sm text-foreground-500">
        抱歉，您访问的页面可能已被移除或链接有误。
      </p>
      <p className="mt-1 text-xs text-foreground-400 font-mono break-all max-w-full">
        {location.pathname}
      </p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="px-6 h-11 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="px-6 h-11 inline-flex items-center justify-center gap-2 rounded-md bg-background-100 border border-background-200 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-movie-2-line"></i>
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}